import { style, styleVariants } from '@vanilla-extract/css';
import { vars } from '../../theme';
import { reducedMotion } from '../../theme/media';

export const base = style({
  display: 'inline-block',
  borderRadius: '50%',
  flexShrink: 0,
  transition: `background ${vars.animation.duration.medium} ${vars.animation.easing.easeOut}, box-shadow ${vars.animation.duration.medium} ${vars.animation.easing.easeOut}`,

  '@media': {
    [reducedMotion]: {
      transition: 'none',
    },
  },
});

export const stateStyles = styleVariants({
  online: {
    background: vars.bright.status.success,
    boxShadow: `0 0 4px ${vars.bright.status.success}`,
  },
  offline: {
    background: vars.typography.textColor.tertiary,
    opacity: 0.5,
  },
});
